var module = angular.module('octopusApp.configuration');

module.controller('UsersInviteController', function($scope, busy, octopusRepository, octopusClient) {
  var isLoading = $scope.isLoading = busy.create();
  var isGenerating = $scope.isGenerating = busy.create();

  $scope.invitation = { quantity: 1, teams: [] };

  isLoading.promise(octopusRepository.Teams.all().then(function(teams){
    $scope.teams = _.filter(teams, function(t) { return t.Id !== "teams-everyone"; });

  }));

  $scope.generateInvitations = function() {
    if ($scope.invitation.quantity <= 0) {
      isGenerating.showError('At least one invitation must be created');
      return;
    }

    $scope.invitations = [];
    var push = function(invitation) {
      $scope.invitations.push(invitation);
    };

    // Need to add a bulk API
    var countRemaining = $scope.invitation.quantity;
    var all = [];
    while (countRemaining > 0) {
      countRemaining--;
      var teamIds = $scope.invitation.teams.map(function(team){return team.Id;});
      all.push(octopusRepository.Users.invite(teamIds).then(push));
    }
    isGenerating.promises(all);
  };

  $scope.resolveLink = function(link) {
    return octopusClient.resolve(link);
  };

  $scope.more = function() {
    $scope.invitations = [];
  };
});






//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/users/controllers/users_invite_controller.js
// module id = 6807706289832465
// module chunks = 1